






















































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import * as Y from 'yjs'
import { bytesToBase64 } from 'byte-base64'
import { debounce } from 'quasar'
import confirm from 'components/modals/Confirm'
import arrayCrdtSortNumber from 'src/assets/arrayCrdtSortNumber'
import AnswersSortableList from 'components/presenter/item/topic/editor/AnswersEditorSortableList.vue'
import AnswersSortableListItem from 'components/presenter/item/topic/editor/AnswersEditorSortableListItem.vue'
import MarkdownEditor from 'components/MarkdownEditor.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    AnswersSortableList,
    AnswersSortableListItem,
    MarkdownEditor
  }
})
export default class ItemTopicSlidesEditorAnswersEditor extends Vue {
  answers: Json[] = []
  reorder = false
  text = ''
  enter = true

  @Prop()
  readonly item!: Item

  @Prop()
  readonly slide!: Json

  @Prop()
  readonly placeholder!: string

  @Ref()
  readonly editor!: MarkdownEditor

  @Watch('slide.answers', { immediate: true, deep: true })
  updateAnswers (answers: Json | undefined) {
    this.answers = Object.values(answers || {}).filter(a => !a.deleted).sort((a, b) => (a as Json).sort - (b as Json).sort) as Json[]
  }

  created () {
    this.focusEditor = debounce(this.focusEditor, 500)
  }

  typing (input: string) {
    this.text = input
  }

  enterKey (input: string, event?: KeyboardEvent) {
    if (this.enter) {
      event && event.preventDefault()
      this.addAnswer(new Date().getTime().toString(), input)
    }
  }

  ctrlEnter (input: string) {
    this.addAnswer(new Date().getTime().toString(), input)
  }

  btnAdd () {
    this.addAnswer(new Date().getTime().toString(), this.text)
  }

  addMultipleAnswers () {
    let id = new Date().getTime()
    const texts = this.text.split('\n')
    for (let text of texts) {
      this.addAnswer(`${id++}`, text)
    }
  }

  addAnswer (id: string, value = '') {
    const text = value.trim()
    if (text) {
      const ydoc = new Y.Doc()
      ydoc.getText().insert(0, text)
      const ystate = Y.encodeStateAsUpdate(ydoc)
      const slidesSettings: Json = {}
      const slidesTexts: Json = {}
      slidesSettings[`${this.slide.id}:answers:${id}:id`] = id
      slidesSettings[`${this.slide.id}:answers:${id}:sort`] = arrayCrdtSortNumber(this.answers)
      slidesTexts[`${this.slide.id}:answers:${id}:text`] = [bytesToBase64(ystate)]
      this.item.data?.save({ slidesSettings, slidesTexts })
      this.focusEditor()
    }
    this.text = ''
  }

  focusEditor () {
    this.$nextTick(() => { this.editor.focus() })
  }

  moveAnswer ({ newIndex, oldIndex }: { newIndex: number, oldIndex: number }) {
    const answer = this.answers[oldIndex]
    const slidesSettings: Json = {}
    slidesSettings[`${this.slide.id}:answers:${answer.id}:sort`] = arrayCrdtSortNumber(this.answers, newIndex, oldIndex)
    this.item.data?.save({ slidesSettings })
  }

  async deleteAnswer (answer: Json) {
    await confirm({
      title: this.$t('label.deleteConfirm').toString(),
      message: this.$t('slides.edit.answers.delete').toString(),
      btnRight: this.$t('label.delete').toString(),
      btnRightColor: 'warning'
    })
    const slidesSettings: Json = {}
    slidesSettings[`${this.slide.id}:answers:${answer.id}:deleted`] = new Date().getTime()
    this.item.data?.save({ slidesSettings })
  }
}
